module.exports = __webpack_public_path__ + "img/6.17d5efc5.jpg";